import { useEffect, useState } from 'react'

import { bankData } from '../../data'
import { BankData } from '../../types'
import CheckBox from '../Checkbox/CheckBox'
import { ViewTable } from '../CreditGetEasyBlock/CreditGetEasy'

import ConditionsList from './ConditionsList/ConditionsList'

import cl from './CreditConditions.module.scss'

const CreditConditions = () => {
	const [viewTable, setViewTable] = useState<string>(ViewTable.Online)
	const [contentData, setContentData] = useState<BankData[]>(bankData.online)

	useEffect(() => {
		setContentData(viewTable === ViewTable.Online ? bankData.online : bankData.offline)
	}, [viewTable])
	return (
		<section className={cl.conditions}>
			<h2 className={cl.conditions__title}>Прозрачные условия оформления</h2>
			<div className={cl.conditions__actionWrapper}>
				<CheckBox
					items={[
						{ title: `На сайте`, value: ViewTable.Online },
						{ title: `В магазине`, value: ViewTable.Offline }
					]}
					changeHandler={setViewTable}
				/>
				<ConditionsList data={contentData} />
			</div>
		</section>
	)
}

export default CreditConditions
